export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fABc4EsA.woff2";